import CryptoJS from "crypto-js";

export const AESEncryptData = (plain_text) => {
  var keyHex = CryptoJS.enc.Utf8.parse("Ss*$saAY8hrnR@K^");
  var encrypted = CryptoJS.AES.encrypt(plain_text, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
 
  return encrypted.toString();
};
